class GovernmentBondBenchmark {
    coupon;
    maturity;
    name;
    onTheRun;
    side;
    type;
    constructor(response) {
        this.coupon = response.coupon;
        this.maturity = response.maturity;
        this.name = response.name;
        this.onTheRun = response.onTheRun;
        this.side = response.side;
        this.type = response.type;
    }
    printShort() {
        switch (this.type) {
            case 'BONO':
                return 'SPGB';
            case 'BTP':
                return 'BTP';
            case 'BUND':
                return 'B';
            case 'CAN':
                return 'CAN';
            case 'GILT':
                return 'UKT';
            case 'OAT':
                return 'OAT';
            case 'OBL':
                return 'B';
            case 'OLO':
                return 'OLO';
            case 'UST':
                return 'T';
            case 'NZGB':
                return 'NZGB';
            default:
            //
        }
        if (this.onTheRun !== undefined) {
            return 'T';
        }
        return 'UNKNOWN';
    }
    ;
}
export default GovernmentBondBenchmark;
